export var FipaEventStatus;
(function (FipaEventStatus) {
    FipaEventStatus["Draft"] = "draft";
    FipaEventStatus["Proposed"] = "proposed";
    FipaEventStatus["Published"] = "published";
    FipaEventStatus["Declined"] = "declined";
    FipaEventStatus["ScheduleProposed"] = "schedule_proposed";
    FipaEventStatus["ScheduleDeclined"] = "schedule_declined";
    FipaEventStatus["RegistrationOpen"] = "registration_open";
    FipaEventStatus["RegistrationClosed"] = "registration_closed";
    FipaEventStatus["EventRunning"] = "event_running";
    FipaEventStatus["EventEnded"] = "event_ended";
    FipaEventStatus["ResultsPublished"] = "result_published";
    FipaEventStatus["Cancelled"] = "cancelled";
})(FipaEventStatus || (FipaEventStatus = {}));
